import {
    STORE_REPLACE_PINWHEEL_SURVEY_OPTIONS,
    STORE_RESET_PINWHEEL_SURVEY,
} from '@perpay-web/fintech/constants/actionTypes';

const initialState = {};

const surveyOptionsReducer = (state = initialState, action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case STORE_REPLACE_PINWHEEL_SURVEY_OPTIONS:
            return { ...state, ...payload };
        case STORE_RESET_PINWHEEL_SURVEY:
            return initialState;
        default:
            return state;
    }
};

export default surveyOptionsReducer;
